import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner, Badge, Button, Form, InputGroup, Table } from "react-bootstrap";
import { getuserdata, encryptId } from "../../services/apiService";
import { oneKlicks } from "../../SDK/oneclick";
import Paginationnew from "../../Uitiles/Paginationnew";


const Invoices = () => {
    const navigate = useNavigate();
    const [userdata, setUserdata] = useState({});
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedInvoicetype, setSelectedInvoicetype] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [userType, setUserType] = useState('');


    useEffect(() => {
        getUserData();
    }, []);

    useEffect(() => {
        if (userdata?.id) {
            console.log('Fetching invoices for user:', userdata.id);
            getInvoices();
        }
    }, [userdata.id, selectedInvoicetype, searchText, page]);

    const getUserData = async () => {
        try {
            const userData = await getuserdata("full");
            console.log("userData fetched:", userData);
            if (userData && userData.id) {
                setUserdata(userData);
                setUserType(userData.user_type);
            } else {
                console.error("No user data or user ID found");
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    const getInvoices = async () => {
        try {
            setLoading(true);
            console.log('📄 Starting getInvoices...');
            console.log('📄 User ID:', userdata.id);

            const tableSchema = "";
            const tableName = "invoices";
            const conditions = {
                "client": userdata.id
            };
            console.log('📄 Query conditions:', conditions);

            const orderBy = "id DESC";
            const search = {
                ...(selectedInvoicetype ? { status: selectedInvoicetype } : {}),
                ...(searchText && {
                    id: searchText,
                    amount: searchText,
                    status: searchText
                })
            };
            console.log('📄 Search filters:', search);

            const pagination = {
                page: page,
                limit: limit
            };
            const margedata = [];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("📄 getInvoices response:", response);
            console.log("📄 Invoices data:", response?.data);
            console.log("📄 Invoices count:", response?.data?.length);

            if (response.success && response.data.length > 0) {
                setInvoices(response.data);
                setTotalPages(response.totalPages);
                console.log('✅ Invoices loaded successfully:', response.data.length);
            } else {
                setInvoices([]);
                setTotalPages(0);
                console.log('⚠️ No invoices found or empty response');
            }
        } catch (error) {
            console.error("❌ Error fetching invoices:", error);
            setInvoices([]);
        } finally {
            setLoading(false);
        }
    }

    const handlePayment = (invoiceId) => {
        const incroprate_id = encryptId(invoiceId);
        const basePath = userType === 'doctor' ? '/doctor' : '/hospital';
        navigate(`${basePath}/payment/${incroprate_id}`);
    };

    const getStatusBadge = (status) => {
        const statusLower = status?.toLowerCase() || '';
        const statusCapitalized = status?.charAt(0).toUpperCase() + status?.slice(1) || 'Unknown';

        if (statusLower === "pending" || statusLower === "overdue") {
            return <Badge bg="warning" style={{ padding: '5px 10px', fontSize: '11px', fontWeight: '600', borderRadius: '5px' }}>{statusCapitalized}</Badge>;
        } else if (statusLower === "paid") {
            return <Badge bg="success" style={{ padding: '5px 10px', fontSize: '11px', fontWeight: '600', borderRadius: '5px' }}>{statusCapitalized}</Badge>;
        } else if (statusLower === "partial_payment") {
            return <Badge bg="info" style={{ padding: '5px 10px', fontSize: '11px', fontWeight: '600', borderRadius: '5px' }}>Partial</Badge>;
        } else {
            return <Badge bg="secondary" style={{ padding: '5px 10px', fontSize: '11px', fontWeight: '600', borderRadius: '5px' }}>{statusCapitalized}</Badge>;
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "N/A";
        try {
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return "N/A";
            return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
        } catch (error) {
            return "N/A";
        }
    };

    return (
        <div className="container-fluid py-3">
            <div className="card mb-5">
                <div className="card-body">
                    <div className="align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <h5 className="mb-0 font-weight-bold mr-3">Invoices</h5>
                            <Badge bg="info">
                                {userType === 'doctor' ? 'Doctor' : userType === 'hospitals' ? 'Hospital' : 'User'} Invoices
                            </Badge>
                        </div>
                        <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                            <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                <Form.Control
                                    placeholder="Search invoices..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                />
                            </InputGroup>
                            <Form.Select
                                style={{ width: 150 }}
                                value={selectedInvoicetype || ''}
                                onChange={(e) => setSelectedInvoicetype(e.target.value || null)}
                            >
                                <option value="">All Status</option>
                                <option value="pending">Pending</option>
                                <option value="paid">Paid</option>
                                <option value="overdue">Overdue</option>
                                <option value="partial_payment">Partial</option>
                            </Form.Select>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="card-body">
                    <div className="table-responsive">
                        <Table hover size="sm" className="mb-0 align-middle">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Due Date</th>
                                    <th>Created Date</th>
                                    <th>Amount</th>
                                    <th style={{ width: 120 }}>Status</th>
                                    <th style={{ width: 180 }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={6} className="text-center py-4">
                                            <Spinner animation="border" variant="primary" />
                                            <p className="mt-2 text-muted">Loading invoices...</p>
                                        </td>
                                    </tr>
                                ) : invoices.length === 0 ? (
                                    <tr>
                                        <td colSpan={6} className="text-center text-muted py-4">
                                            No invoices found.
                                        </td>
                                    </tr>
                                ) : (
                                    invoices.map((invoice) => (
                                        <tr key={invoice.id}>
                                            <td>#{invoice.id}</td>
                                            <td>{formatDate(invoice.dueDate)}</td>
                                            <td>{formatDate(invoice.created_at)}</td>
                                            <td style={{ fontWeight: '600', color: '#333' }}>₹{invoice.amount}</td>
                                            <td>{getStatusBadge(invoice.status)}</td>
                                            <td>
                                                <div className="d-flex" style={{ gap: 8 }}>
                                                    {invoice.status === "pending" || invoice.status === "overdue" || invoice.status === "partial_payment" ? (
                                                        <Button
                                                            size="sm"
                                                            variant="primary"
                                                            onClick={() => handlePayment(invoice.id)}
                                                            style={{
                                                                background: 'var(--themecolor)',
                                                                border: 'none',
                                                                borderRadius: '5px'
                                                            }}
                                                        >
                                                            Pay Now
                                                        </Button>
                                                    ) : (
                                                        <Button size="sm" variant="success" disabled style={{ borderRadius: '5px' }}>
                                                            Paid
                                                        </Button>
                                                    )}
                                                    <Button
                                                        size="sm"
                                                        variant="outline-secondary"
                                                        onClick={() => window.open(`//css.meddylist.com//my-account/view-order/${invoice.id}/`, '_blank')}
                                                        style={{ borderRadius: '5px' }}
                                                    >
                                                        View
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>

                    {!loading && invoices.length > 0 && (
                        <Paginationnew
                            currentPage={page}
                            totalPages={totalPages}
                            handlePageChange={setPage}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Invoices;
